import { render, staticRenderFns } from "./fbpTransactions.vue?vue&type=template&id=a177f61a&scoped=true"
import script from "./fbpTransactions.vue?vue&type=script&lang=js"
export * from "./fbpTransactions.vue?vue&type=script&lang=js"
import style0 from "./fbpTransactions.vue?vue&type=style&index=0&id=a177f61a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a177f61a",
  null
  
)

export default component.exports